import { useCallback } from "react";
import { z } from "zod";
import React from "react";
import { Button } from "@zapier/design-system";

import styles from "../shared/buttonStyles.module.css";
import { ContinueButtonParamsSchema } from "./index";

export type ContinueButtonParams = z.infer<typeof ContinueButtonParamsSchema>;

export function ContinueButton() {
  const handleButtonClick = useCallback(async () => {
    // Send continue message via postMessage to the copilot chat
    window.postMessage(
      {
        type: "COPILOT_USER_MESSAGE",
        payload: {
          message: "continue",
          source: "continue_button",
        },
      },
      "*",
    );
  }, []);

  return (
    <div className={styles.container}>
      <Button variant="primary" size="compact" onPress={handleButtonClick}>
        Continue
      </Button>
    </div>
  );
}
